import { createContext, useCallback, useContext, useState } from "react";
import { getDetailAndSimulation } from "../../../../config";

export const SimulationConexts = createContext({ project: null, updateProject: () => { }, isLoading: true, updateClickupSpace: async () => { } });

export const GetSimulationContext = () => {
    const { project, updateClickupSpace, updateProject, isLoading } = useContext(SimulationConexts);

    return { project, updateClickupSpace, updateProject, isLoading };
};

const SimulationProvider = ({ children }) => {
    const [project, setProject] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [clickupSpace, setClickupSpace] = useState(null);

    const updateProject = useCallback(async () => {
        if (!clickupSpace) return;
        setIsLoading(true);
        try {
            const { payload: projectData } = await getDetailAndSimulation(clickupSpace);
            setProject(projectData);
        } finally {
            setIsLoading(false);
        }
    }, [clickupSpace]);

    const updateClickupSpace = (clickupSpace) => {
        setClickupSpace(clickupSpace);
    };

    return <SimulationConexts.Provider value={{ project, updateProject, isLoading, updateClickupSpace }}>{children}</SimulationConexts.Provider>;
};

export default SimulationProvider;
